import { useExternalSystems } from '../useExternalSystems/useExternalSystems';
import { useVenues } from '../useVenues/useVenues';
import { getVenuesToPublishTo } from '../useExternalSystemPublishing/getVenuesToPublishTo/getVenuesToPublishTo';
import { IPublishDestination } from 'src/components/PublishModal/types';
import { canReceiveTimetable } from './canReceiveTimetable';

/**
 * One destination per extension instance that can receive a timetable, rather than one per external
 * system as `useExternalSystemPublishing` lists them. `channel_id` stays the external system because
 * venues link there; `destination_id` carries the instance id.
 */
export const useTimetablePublishDestinations = () => {
  const venuesQuery = useVenues({ enabled: true });
  const externalSystemsQuery = useExternalSystems();

  const isLoading = venuesQuery.isLoading || externalSystemsQuery.isLoading;
  const isError = venuesQuery.isError || externalSystemsQuery.isError;

  if (isLoading || isError) {
    return { data: [] as IPublishDestination[], isLoading, isError };
  }

  const data: IPublishDestination[] = (externalSystemsQuery.data ?? []).flatMap((externalSystem) => {
    // No aggregator: it only decorates venues with a menu's publication status.
    const venues = getVenuesToPublishTo(venuesQuery.data ?? [], externalSystem.aggregatorId, undefined, false);
    if (venues.length === 0) return [];

    return externalSystem.configuredAddons.filter(canReceiveTimetable).map(
      (instance): IPublishDestination => ({
        destination_id: instance.instanceId,
        channel_id: externalSystem.aggregatorId,
        extensionInstanceId: instance.instanceId,
        name: `${instance.addonName} - ${instance.instanceName}`,
        venues,
      }),
    );
  });

  return { data, isLoading, isError };
};
